import React from 'react';
import '../../styles/nirf/main.css';

const Main = () => {
    return (
        <div id='nirfMain'>
            <div className="nirf-main">
                <div className="container main-box pb-5">
                    <div className="box">
                        <h1 className="my-heading">Data NIRF</h1>
                        <div className="details" id="governance">
                            <a
                                id="nirf-login-btn"
                                href="https://forms.ccsuforms.in/CCS_NIRF/"
                                target="_blank"
                                without rel="noreferrer"
                            >
                                NIRF LOGIN
                            </a>
                            <div className="sec-box mt-3">
                                <div className="col-lg-12 col-sm-12 content">
                                    <table width="100%" className="">
                                        <tbody>
                                            <tr>
                                                <th colSpan={2}>Data NIRF-2026</th>
                                            </tr>
                                            <tr>
                                                <td width="25%">NIRF_OVERALL_2026</td>
                                                <td width="75%">
                                                    <a
                                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/03/NIRF-2026_OVERALL.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Data NIRF-2025</th>
                                            </tr>
                                            <tr>
                                                <td width="25%">NIRF_OVERALL_2025</td>
                                                <td width="75%">
                                                    <a
                                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/03/NIRF-2025_OVERALL.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Data NIRF-2024</th>
                                            </tr>
                                            <tr>
                                                <td width="25%">NIRF_OVERALL_2024</td>
                                                <td width="75%">
                                                    {/* <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/02/nirf_2024_overall_29-02-2024_1709186639.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a> */}
                                                    <a
                                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/03/NIRF-2024_OVERALL.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a>
                                                </td>
                                            </tr>
                                            {/* <tr>
                                                <td>NIRF_ENGG</td>
                                                <td>
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/vol-2.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a>
                                                </td>
                                            </tr> */}
                                            {/* <tr>
                                                <td>NIRF_LAW</td>
                                                <td>
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/vol-2.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a>
                                                </td>
                                            </tr> */}
                                            <tr>
                                                <th colSpan={2}>Data NIRF-2023</th>
                                            </tr>
                                            <tr>
                                                <td width="25%">NIRF_OVERALL_2023</td>
                                                <td width="75%">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/nirf-2023-overall.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Data NIRF-2022</th>
                                            </tr>
                                            {/* <tr>
                                                <td width="25%">ENGINEERING</td>
                                                <td width="75%">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/ENGGINERERING.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a>
                                                </td>
                                            </tr> */}
                                            {/* <tr>
                                                <td width="25%">MANAGEMENT</td>
                                                <td width="75%">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/MANAGEMENT.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a>
                                                </td>
                                            </tr> */}
                                            {/* <tr>
                                                <td width="25%">LAW</td>
                                                <td width="75%">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/LAW.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a>
                                                </td>
                                            </tr> */}
                                            <tr>
                                                <td width="25%">NIRF_OVERALL_2022</td>
                                                <td width="75%">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/OVERALL.pdf"
                                                        target="_blank"
                                                        without rel="noreferrer"
                                                        className="stylered"
                                                    >
                                                        <strong>Click to View</strong>
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;